import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"

export default ({ data }) => (
  <Layout>
    <div>
      {data.allMarkdownRemark.edges.map(({ node }) => (
        <div key={node.id}>
          <Link
            to={node.fields.slug}
            style={{
              textDecoration: `none`,
              color: `inherit`,
            }}
          >
            <h3
              style={{
                marginBottom: `4px`,
                fontSize: `18px`,
              }}
            >
              {node.frontmatter.title}{" "}
              <span
                style={{
                  color: `#bbb`,
                }}
              >
                — {node.frontmatter.date}
              </span>
            </h3>
            <p>{node.excerpt}</p>
          </Link>
        </div>
      ))}
    </div>
  </Layout>
)

export const query = graphql`
  query($dir: String!) {
    allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: $dir } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      totalCount
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
          }
          excerpt
        }
      }
    }
  }
`
